<template>
  <div class="control-crosshair">
    <x-icon icon="crosshairs" color="#fff" aria-label="map center crosshairs" />
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import xIcon from '@/components/shared/x-icon'

export default {
  name: 'ControlCrosshair',
  components: {
    xIcon,
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.control-crosshair {
  position: absolute;
  top: 0;
  width: calc(100% - var(--map-side-nav-width));
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  margin-left: var(--map-side-nav-width);
}

@media print {
  .control-crosshair {
    display: none;
  }
}
</style>
